import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/data/content";

export const MarqueeStrip = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative py-8 md:py-12 bg-forest overflow-hidden"
    >
      <div className="noise-overlay absolute inset-0 opacity-[0.12] pointer-events-none" />
      <Marquee speed={55} gradient={false} className="marquee-mask">
        {MARQUEE_WORDS.concat(MARQUEE_WORDS).map((w, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`font-display font-black text-5xl md:text-8xl px-6 md:px-10 tracking-tighter ${
                i % 2 === 0 ? "text-white" : "text-stroke-cream"
              }`}
            >
              {w}
            </span>
            <span className="text-green text-4xl md:text-7xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
